import { getCookieValue } from '@lingoda/cookie';
import { COOKIE_BEARER_KEY } from './constants';

export const getAuthToken = () => getCookieValue(COOKIE_BEARER_KEY);
